<template>
  <div class="dt-details">
    <div class="dt-details--header">{{$t('tab_title_invoice_reminder')}}</div>
    <div class="dt-details--body" v-if="invoiceReminder">
      <div class="dt-details--col">
        <div class="dt-details--row">
          <div class="dt-details--label">{{$t('date')}}</div>
          <div class="dt-details--value" :title="invoiceReminder.date">
            <div>{{invoiceReminder.date}}</div>
          </div>
        </div>
      </div>
      <div class="dt-details--col">
        <div class="dt-details--row">
          <div class="dt-details--label">{{$t('Reminder Type')}}</div>
          <div class="dt-details--value" :title="invoiceReminder.invoice_reminder_type">
            <div>{{invoiceReminder.invoice_reminder_type}}</div>
          </div>
        </div>
      </div>
      <div class="dt-details--col">
        <div class="dt-details--row">
          <div class="dt-details--label">{{$t('subject')}}</div>
          <div class="dt-details--value" :title="invoiceReminder.subject">
            <div>{{invoiceReminder.subject}}</div>
          </div>
        </div>
      </div>
      <div class="dt-details--col">
        <div class="dt-details--row">
          <div class="dt-details--label">{{$t('Bank Check Date')}}</div>
          <div class="dt-details--value" :title="invoiceReminder.account_check_date">
            <div>{{invoiceReminder.account_check_date}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    invoiceReminder: {
      type: Object
    }
  }
};
</script>

<style>
</style>
